import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, BookOpen } from 'lucide-react';

const BlogPage = () => {
  useEffect(() => {
    // Carica lo script Soro
    const script = document.createElement('script');
    script.src = 'https://app.trysoro.com/api/embed/dc8cc996-f8f5-4d6d-9ddf-34b139512c5e';
    script.defer = true;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script quando si lascia la pagina
      const existingScript = document.querySelector('script[src*="trysoro.com"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF9F6]">
      {/* Header */}
      <header className="bg-white border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img 
              src="/images/curacheck-logo.png" 
              alt="CuraCheck" 
              className="h-10 w-auto"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <span className="text-xl font-bold text-[#2C3E50]">CuraCheck</span>
          </Link>
          
          <Link 
            to="/"
            className="flex items-center gap-2 text-[#4A7C59] hover:text-[#3D6A4B] transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Torna al sito
          </Link>
        </div>
      </header>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#4A7C59] to-[#2C5530] text-white py-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <BookOpen className="w-10 h-10" />
            <h1 className="text-4xl md:text-5xl font-bold">Blog CuraCheck</h1>
          </div>
          <p className="text-xl text-white/80 max-w-2xl mx-auto">
            Consigli, guide e approfondimenti per prenderti cura dei tuoi cari con serenità
          </p>
        </div>
      </section>

      {/* Blog Content - Soro Widget */}
      <main className="max-w-6xl mx-auto px-4 py-12">
        <div id="soro-blog" className="min-h-[500px]">
          {/* Loading state while Soro loads */}
          <div className="flex items-center justify-center py-20">
            <div className="text-center">
              <div className="w-12 h-12 border-4 border-[#4A7C59] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
              <p className="text-gray-500">Caricamento articoli...</p>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#2C3E50] text-white py-8">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <p className="text-white/60">
            © {new Date().getFullYear()} CuraCheck. Tutti i diritti riservati.
          </p>
          <div className="flex justify-center gap-6 mt-4">
            <Link to="/" className="text-white/80 hover:text-white transition-colors">
              Home
            </Link>
            <Link to="/login" className="text-white/80 hover:text-white transition-colors">
              Accedi
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BlogPage;
